import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useFeatureFlagState } from 'context';
import { CompareHomeActivityFeedQuery } from 'services/apollo';

interface HomeActivityFeedPolling {
  setPollingResult: any;
}
export const HomeActivityFeedPolling = ({ setPollingResult }: HomeActivityFeedPolling) => {
  const { groupsFeatureFlag } = useFeatureFlagState();

  const { data: pollingData, stopPolling } = useQuery(CompareHomeActivityFeedQuery, {
    variables: {
      first: 20,
      cursor: '',
      includeGroups: groupsFeatureFlag ? true : false,
      customIdentifier: 'homePolling',
      errorPolicy: 'all',
    },
    pollInterval: 300000,
    fetchPolicy: 'network-only',
  });

  /**
   * Starts and stops polling
   */
  useEffect(() => {
    return () => {
      stopPolling();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (pollingData != null) {
    setPollingResult(pollingData);
  }

  return <div></div>;
};
